"use strict";

module.exports = "\n<svg class=\"bvp-icon circle\" viewBox=\"0 0 60 60\">\n  <circle cx=\"30\" cy=\"30\" r=\"28\" stroke=\"#fff\" stroke-width=\"2\" stroke-opacity=\"0.8\" fill=\"#000\" fill-opacity=\"0.3\" />\n</svg>\n";